import React from 'react';
import * as PropTypes from 'prop-types';
import {
  ActivityCard,
  Highlight,
  CardActionArea,
  ActivityIcon,
  InfoContainer,
  Title,
  Text,
  LogLoader,
  LogButton,
  CardActions,
} from './elements';
import Lab022 from 'dc/Lab022';

function ActCard(props) {
  return (
    <ActivityCard className={props.className}>
      <Highlight color={props.categoryColor} />
      <CardActionArea
        onClick={props.onActivityClick}
        aria-label={`${props.ariaDescription} ${props.title}`}
      >
        <ActivityIcon alt={props.activityIconAlt} icon={props.activityIcon} />
        <InfoContainer>
          <Title>{props.title}</Title>
          <Lab022 indicators={props.indicators} logged={props.timesLogged} />
          <Text>{props.ctaText}</Text>
        </InfoContainer>
      </CardActionArea>
      <CardActions>
        {props.isLogging ? (
          <LogLoader icon={'icon-check'} />
        ) : (
          <LogButton
            ariaLabel={`${props.ariaLabelLogButton} ${props.title}`}
            onClick={props.onLogClick}
            disabled={props.disabled}
            checked={props.checked}
          />
        )}
      </CardActions>
    </ActivityCard>
  );
}

ActCard.propTypes = {
  ariaDescription: PropTypes.string,
  ariaLabelLogButton: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  ctaText: PropTypes.string,
  indicators: PropTypes.array,
  onActivityClick: PropTypes.func,
  activityIcon: PropTypes.string,
  activityIconAlt: PropTypes.string,
  onLogClick: PropTypes.func,
  isLogging: PropTypes.bool,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  categoryColor: PropTypes.string,
  timesLogged: PropTypes.number,
};

export default ActCard;
